export default "__VITE_ASSET__DBUYiSWz__"